//@flow
import React, { useEffect } from 'react';
import MediaQuery from 'react-responsive';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { FilterButton } from 'components/atoms/filtersButton';
import { FormatHeader } from 'components/atoms/formatHeader';
import closeIcon from 'assets/images/close.png';
import closeWhiteIcon from 'assets/images/closewhite.png';
import classNames from 'classnames';

type Props = {
  theme: string,
  breadcrumbList: Array,
  onMenuPress: () => void,
  isMobile?: boolean,
  type: string,
  activeFilters: Array<string>,
  showFilter?: boolean,
};

export const OverlayHeader = (props: Props) => {
  const {
    theme,
    breadcrumbList,
    onMenuPress,
    isMobile,
    type,
    activeFilters = [],
    showFilter = true,
    headerClass,
  } = props;

  const icon = theme === 'light-theme' ? closeIcon : closeWhiteIcon;
  const containerClass = classNames('header-section', headerClass);

  const renderFilter = () => {
    switch (type) {
      case 'projects':
      case 'products':
      case 'past-events':
      case 'upcoming-events-desktop':
      case 'architecture-projects':
      case 'rentals':
        return renderProjectFilter();
      case 'neighbourhood':
        return null;
      default:
        return null;
    }
  };

  const renderProjectFilter = () => {
    if (showFilter) {
      return (
        <FilterButton
          className={'overlay-filter'}
          isMobile={isMobile}
          theme={theme}
          filterType={type}
          activeFilters={activeFilters}
        />
      );
    } else return null;
  };

  return (
    <>
      <MediaQuery minDeviceWidth={576}>
        <Row className={containerClass}>
          <Col md={1}>
            <Row>
              <Col xs={6} sm={6} md={6}>
                <a onClick={onMenuPress} className={'menu-close-icon'}>
                  <img src={icon} alt={'icon'} />
                </a>
              </Col>
            </Row>
          </Col>
          <Col md={3}>
            <Breadcrumb>
              {/*<Breadcrumb.Item href="#">*/}
              {/*  <FormatHeader*/}
              {/*    breadcrumbText={*/}
              {/*      breadcrumbList ? breadcrumbList[0] : 'TotalEnvironment'*/}
              {/*    }*/}
              {/*  />*/}
              {/*</Breadcrumb.Item>*/}
              {/*{breadcrumbList[1] ? (*/}
              {/*  <Breadcrumb.Item href="#">{breadcrumbList[1]}</Breadcrumb.Item>*/}
              {/*) : null}*/}

              {breadcrumbList.map((item, idx) => {
                if (idx === 0) {
                  return (
                    <Breadcrumb.Item
                      href={item.breadcrumbLink}
                      key={item.breadcrumbName}
                    >
                      <FormatHeader breadcrumbText={item.breadcrumbName} />
                    </Breadcrumb.Item>
                  );
                } else {
                  return (
                    <Breadcrumb.Item
                      href={item.breadcrumbLink}
                      key={item.breadcrumbName}
                    >
                      {item.breadcrumbName}
                    </Breadcrumb.Item>
                  );
                }
              })}
            </Breadcrumb>
          </Col>
          <Col md={8}>{renderFilter()}</Col>
        </Row>
      </MediaQuery>
    </>
  );
};
